import { render } from "./UserInfoDetail.vue?vue&type=template&id=80705ef8&ts=true"
import script from "./UserInfoDetail.vue?vue&type=script&lang=ts"
export * from "./UserInfoDetail.vue?vue&type=script&lang=ts"

import "./UserInfoDetail.vue?vue&type=style&index=0&id=80705ef8&lang=css"

import exportComponent from "D:\\Work\\IMMS\\IMMSV3\\App\\IMMS.MasterClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/UserInfoDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "80705ef8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('80705ef8', __exports__)) {
    console.log('reload')
    api.reload('80705ef8', __exports__)
  }
  
  module.hot.accept("./UserInfoDetail.vue?vue&type=template&id=80705ef8&ts=true", () => {
    console.log('re-render')
    api.rerender('80705ef8', render)
  })

}


export default __exports__